import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row-top h-full institute-container" }
const _hoisted_2 = { class: "flex-col gap-01 flex-1" }
const _hoisted_3 = { class: "font-lBold" }
const _hoisted_4 = { class: "font-lBold" }
const _hoisted_5 = { class: "flex-col gap-10 mtop-04 w-full" }
const _hoisted_6 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_7 = { class: "font-mBold min-label-width" }
const _hoisted_8 = { class: "flex-row align-center gap-10 w-full" }
const _hoisted_9 = { class: "font-mBold min-label-width" }
const _hoisted_10 = { class: "col gap-12px" }
const _hoisted_11 = { class: "flex-row" }
const _hoisted_12 = { class: "font-lBold" }
const _hoisted_13 = { class: "row-top gap-10 mtop-04 flexwrap" }
const _hoisted_14 = { class: "col pleft-30px gap-04" }
const _hoisted_15 = { class: "flex-row gap-02" }
const _hoisted_16 = { class: "flex-row mtop-10" }
const _hoisted_17 = { class: "font-lBold" }
const _hoisted_18 = { class: "bg-modal w-maxC" }
const _hoisted_19 = { class: "row-top gap-10 mtop-04 flexwrap" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "flex-row" }
const _hoisted_24 = { class: "font-lBold" }
const _hoisted_25 = { class: "flex-row gap-10 mtop-04 w-full" }
const _hoisted_26 = { class: "flex-col pleft-30px" }
const _hoisted_27 = { class: "flex-col gap-02" }
const _hoisted_28 = { class: "flex-col gap-20" }
const _hoisted_29 = { class: "font-lBold" }
const _hoisted_30 = {
  key: 0,
  class: "flex-col gap-02"
}
const _hoisted_31 = {
  for: "slug",
  class: "h4"
}
const _hoisted_32 = { class: "flex-col gap-02" }
const _hoisted_33 = { class: "flex-col gap-02" }
const _hoisted_34 = { class: "flex-col gap-02" }

import headerInput from '@/views/patientMain/dashbAdmin/person/headerInput.vue';
import { useAppUserStore } from "@/stores/appUser";
import esWaitingRoomSettings from "@/views/officeMain/settings/esWaitingRoomSettings.vue";
import { useToast } from "primevue";
import { useI18n } from 'vue-i18n';
import { computed, onMounted, ref, watch } from "vue";
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { AddressRequest, ApiError, InstituteAddress, InstituteApi, InstituteEmail, InstituteEmailRequest, InstituteInformation, InstitutePhone, InstitutePhoneRequest, UpdateAddressByInstituteRequest, UpdateEmailByInstituteRequest, UpdateInstituteRequest, UpdatePhoneByInstituteRequest, UpsertInstituteInformation } from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import esParkingSettings from "@/views/officeMain/settings/esParkingSettings.vue";
import esTransportStopSettings from "@/views/officeMain/settings/esTransportStopSettings.vue";
import esInstituteSlugSettings from "@/views/officeMain/settings/esInstituteSlugSettings.vue";
import PhoneInput from '@/views/patientMain/dashbAdmin/person/phoneInput.vue';
import EmailInput from '@/views/patientMain/dashbAdmin/person/emailInput.vue';
import AddressInput from '@/views/patientMain/dashbAdmin/person/addressInput.vue';
import EsDataCard from '@/components/esDataCard.vue';
import gen from '@/functions/general';
import { PHONE_PREFIX_LIST, getFlagEmojiForPrefix, getFlagEmojiForCountry } from "@/functions/geo";
import officeapi from '@/api/officeapi';
import EsEditor from '@/components/esEditor.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbInstituteSettings',
  emits: ['refresh-calendar'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const appUserStore = useAppUserStore();
const toast = useToast();

const emits = __emit;

const instituteApi = new InstituteApi(medServerApiConfig);

const dropd = ref("");
const instituteAddresses = ref<InstituteAddress[]>([]);
const instituteEmails = ref<InstituteEmail[]>([]);
const institutePhones = ref<InstitutePhone[]>([]);
const slug = ref<string | null>(null);
const instituteInformation = ref<InstituteInformation>({
  generalMessage: ''
});

const instituteWithRole = appUserStore.currentHealthGroupMembership?.instituteWithRole;

const instituteHeaders = computed(() => {
  const headers = appUserStore.currentHealthGroupMembership?.instituteWithRole?.headers ?? []
  const preferredId = appUserStore.currentHealthGroupMembership?.preferredInstituteHeaderId
  return sortInstituteItems(headers, preferredId, 'instituteHeaderId')
})

function sortInstituteItems(items: any[], preferredId: any, idField: string) {
  if (!items || items.length === 0) return []
  return [...items].sort((a, b) => {
    const aIsPreferred = preferredId != null && a[idField] === preferredId
    const bIsPreferred = preferredId != null && b[idField] === preferredId
    if (aIsPreferred && !bIsPreferred) return -1
    if (!aIsPreferred && bIsPreferred) return 1
    const dateA = a.created ? new Date(a.created).getTime() : 0
    const dateB = b.created ? new Date(b.created).getTime() : 0
    return dateA - dateB
  })
}

function sendEmail(email: string) {
  window.location.href = gen.getEmailUrl(email);
}

function callNumber(phone: InstitutePhone) {
  window.location.href = gen.getTelUrl(phone.phoneNumber, phone.phonePrefix);
}

function contact(rawNumber: string) {
  if (rawNumber === '') return rawNumber;
  return rawNumber.match(/.{1,3}/g).join(' ');
}

/**
 * Updates the institute's custom header lines and general information.
 *
 * This function retrieves the current institute associated with the user's health group membership.
 * It then constructs an update request containing the custom header lines and basic information such as
 * the institute's name and short name. The request is sent to the server via the `InstituteApi`.
 *
 * On success, a success toast notification is displayed.
 * On failure, an error toast notification is shown based on the API error status.
 *
 * @async
 * @function updateIwrHeader
 * @returns {Promise<void>} A promise that resolves once the update is complete or fails.
 */
const updateIwrNames = async () => {
  const instituteWithRole = appUserStore.currentHealthGroupMembership?.instituteWithRole;
  if (!instituteWithRole) return;

  const updateTitle: UpdateInstituteRequest = {
    instituteName: instituteWithRole.instituteName,
    instituteShortName: instituteWithRole.instituteShortName
  };

  await instituteApi.updateInsitute({
    instituteId: instituteWithRole.instituteWithRoleId,
    updateInstituteRequest: updateTitle,
  })
  .then(() => {
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail: t('settings.params.account.toast.update.information'),
    });
  })
  .catch((error: ApiError) => {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t(`error.${error.status}`)
    });
  });
};

const loadSlug = async () => {
  const instituteId = appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId;
  if (!instituteId) {
    return;
  }
  
    const instituteApi = new InstituteApi(medServerApiConfig);
    const { value } = await instituteApi.getInstituteSlug({ instituteId: instituteId });
    slug.value = value ?? null;
}

const onSlugUpdate = (value: string) => {
  slug.value = value;
}

const updateAddress = async (addressRequest: AddressRequest, addressId: string) => {
  if (addressRequest && appUserStore.currentHealthGroupMembership?.instituteWithRole && addressId) {

    const updateAddressByInstituteRequest: UpdateAddressByInstituteRequest = {
      addressId: addressId,
      instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId,
      addressRequest: addressRequest
    };

   instituteApi.updateAddressByInstitute(updateAddressByInstituteRequest).then(async () => {
      await getInstituteAddress();
      dropd.value = '';
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail: t('settings.params.account.toast.update.address')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
    });
  }
}

const updateEmail = async(instituteEmailRequest: InstituteEmailRequest, emailId: string) => {
  if (instituteEmailRequest  && appUserStore.currentHealthGroupMembership?.instituteWithRole && emailId) {
     const updateEmailByInstituteRequest: UpdateEmailByInstituteRequest = {
        emailId: emailId,
        instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId,
        instituteEmailRequest: instituteEmailRequest
      };
    instituteApi.updateEmailByInstitute(updateEmailByInstituteRequest).then(async () => {
      await getInstituteEmails();
      dropd.value = '';
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail: t('settings.params.account.toast.update.email')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
    });
  }
}

const updatePhone = async (institutePhoneRequest: InstitutePhoneRequest, phoneId: string) => {
  if (institutePhoneRequest && appUserStore.currentHealthGroupMembership?.instituteWithRole && phoneId) {
    const updatePhoneByInstituteRequest: UpdatePhoneByInstituteRequest = {
      phoneId: phoneId,
      instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId,
      institutePhoneRequest: institutePhoneRequest
    };

    instituteApi.updatePhoneByInstitute(updatePhoneByInstituteRequest).then(async () => {
      await getInstitutePhones();
      dropd.value = '';
      toastSuccess(toast, {
        summary: t('common.toast.success.update'),
        detail: t('settings.params.account.toast.update.phone')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
    });
  }
}

const deleteEmail = async (emailId: string) => {
  if (appUserStore.currentHealthGroupMembership?.instituteWithRole && emailId) {
    instituteApi.deleteEmailByInstitute({instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId, emailId: emailId}).then(async () => {
      await getInstituteEmails();

      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.email')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const deletePhone = async (phoneId: string) => {
  if (appUserStore.currentHealthGroupMembership?.instituteWithRole && phoneId) {
    instituteApi.deletePhoneByInstitute({instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId, phoneId: phoneId}).then(async () => {
      await getInstitutePhones();
      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.phone')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
}

const deleteAddress = async (addressId: string) => {
  if (appUserStore.currentHealthGroupMembership?.instituteWithRole && addressId) {
    instituteApi.deleteAddressByInstitute({instituteId:appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId, addressId: addressId}).then(async () => {
      await getInstituteAddress();
      
      toastSuccess(toast, {
        summary: t('common.toast.success.delete'),
        detail: t('settings.params.account.toast.delete.address')
      });
    }).catch((error: ApiError) => {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });
    });
  }
} 

const createPhone = async (value: {phonePrefix: string, phoneNumber: string, phoneIsMobile: boolean}) => {
  if (appUserStore.currentHealthGroupMembership?.instituteWithRole && value) {
    
    try {
      await officeapi.addPhoneToIwr(appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId, value.phonePrefix, value.phoneNumber, value.phoneIsMobile);
      await getInstitutePhones();
      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail: t('settings.params.account.toast.add.phone')
      });
    } catch (error: ApiError) {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
    }
  }
}

const createEmail =  async (email: string) => {
  if (appUserStore.currentHealthGroupMembership?.instituteWithRole && email) {
    try {
      await officeapi.addEmailToIwr(appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId, email);
      await getInstituteEmails();

      toastSuccess(toast, {
        summary: t('common.toast.success.add'),
        detail: t('settings.params.account.toast.add.email')
      });
    } catch (error: ApiError) {
      toastError(toast, {
        summary: t('common.toast.error'),
        detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
      });

      // Throw error to set at false the var __alreadyClicked in v-one-click directive
      throw error;
    }
  }
}

const createAddress = async (instituteAddress: InstituteAddress) => {
  if (appUserStore.currentHealthGroupMembership?.instituteWithRole && instituteAddress) {
    instituteApi.createAddressByInstitute({instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId, instituteAddress: instituteAddress})
      .then(async () => {
        await getInstituteAddress();

        toastSuccess(toast, {
          summary: t('common.toast.success.add'),
          detail: t('settings.params.account.toast.add.address')
        });
      }).catch((error: ApiError) => {
        toastError(toast, {
          summary: t('common.toast.error'),
          detail:  error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
        });

        // Throw error to set at false the var __alreadyClicked in v-one-click directive
        throw error;
      });
  }
}

const getInstituteAddress = () => {
  instituteApi.listAddressesByInstitute({instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId})
    .then((result: InstituteAddress[]) => {
      instituteAddresses.value = result;
    });
}

const getInstituteEmails = () => {
  instituteApi.listEmailsByInstitute({instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId})
    .then((result: InstituteEmail[]) => {
      instituteEmails.value = result;
    });
}

const getInstitutePhones = () => {
  instituteApi.listPhonesByInstitute({instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId})
    .then((result: InstitutePhone[]) => {
      institutePhones.value = result;
    });
}

const getInstituteInformation = async () => {
  try {
    const information = await instituteApi.getInstituteInformation({ 
      instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId 
    });
    instituteInformation.value = { ...information };
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
}

const updateInstituteInformation = async () => {
  try {
    await instituteApi.upsertInstituteInformation({ 
      instituteId: appUserStore.currentHealthGroupMembership?.instituteWithRole.instituteWithRoleId,
      upsertInstituteInformation: { ...instituteInformation.value }
    });
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail: t('settings.params.account.toast.update.information'),
    });
  } catch (error: ApiError) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
}

const updateGeneralMessage = async (newValue: string) => {
  instituteInformation.value.generalMessage = newValue;
  await updateInstituteInformation();
}

onMounted(() => {
  getInstituteAddress();
  getInstituteEmails();
  getInstitutePhones();
  getInstituteInformation();
  loadSlug();
})

return (_ctx: any,_cache: any) => {
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_list_group = _resolveComponent("list-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('settings.params.account.prescription.title')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('settings.params.account.prescription.instituteName')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)('settings.params.account.prescription.instituteFullName')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(instituteWithRole).instituteName) = $event)),
            class: "input-style flex-1 pad-m",
            type: "text",
            onBlur: updateIwrNames
          }, null, 544), [
            [_vModelText, _unref(instituteWithRole).instituteName]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)('settings.params.account.prescription.instituteShortName')), 1),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(instituteWithRole).instituteShortName) = $event)),
            class: "input-style flex-1 pad-m",
            type: "text",
            onBlur: updateIwrNames
          }, null, 544), [
            [_vModelText, _unref(instituteWithRole).instituteShortName]
          ])
        ])
      ]),
      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(t)('settings.params.account.details.address')), 1),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewAddress"
          }, {
            dropd: _withCtx(() => [
              _createVNode(AddressInput, {
                pwr: _unref(instituteWithRole),
                onClose: _cache[2] || (_cache[2] = ($event: any) => (dropd.value = '')),
                "owner-type": 'institute',
                iwr: _unref(instituteWithRole),
                onCreateInstituteAddress: _cache[3] || (_cache[3] = ($event: any) => (createAddress($event)))
              }, null, 8, ["pwr", "iwr"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "plus",
                    styles: "main-m"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instituteAddresses.value, (instituteAddress, indexAddress) => {
            return (_openBlock(), _createBlock(_component_dropdownBox, {
              key: indexAddress,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dropd).value = $event)),
              openOn: 'input-address-' + indexAddress,
              class: "cursor-action"
            }, {
              dropd: _withCtx(() => [
                _createVNode(AddressInput, {
                  "is-update": true,
                  "can-delete": instituteAddresses.value.length > 1,
                  ref_for: true,
                  ref: 'input-address-' + indexAddress,
                  address: instituteAddress.address,
                  "owner-type": 'institute',
                  iwr: _unref(instituteWithRole),
                  onClose: _cache[5] || (_cache[5] = ($event: any) => (dropd.value = '')),
                  onUpdateInstituteAddress: ($event: any) => (updateAddress($event, instituteAddress.addressId)),
                  onDeleteInstituteAddress: ($event: any) => (deleteAddress(instituteAddress.addressId))
                }, null, 8, ["can-delete", "address", "iwr", "onUpdateInstituteAddress", "onDeleteInstituteAddress"])
              ]),
              default: _withCtx(() => [
                _createVNode(EsDataCard, {
                  title: _unref(t)('patient.admin.address'),
                  icon: "house_fill",
                  folderIcon: "shareIcons",
                  ref_for: true,
                  ref: "'address-' + indexAddress",
                  backgroundClass: "bg-blue-04"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_text_item, {
                        txt: instituteAddress.address.street,
                        class: "txt-grey-64"
                      }, null, 8, ["txt"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_text_item, {
                          txt: instituteAddress.address.postalCodePrefix ? instituteAddress.address.postalCodePrefix + instituteAddress.address.postalCode : instituteAddress.address.postalCode,
                          class: "txt-grey-64"
                        }, null, 8, ["txt"]),
                        _createVNode(_component_text_item, {
                          txt: instituteAddress.address.locality,
                          class: "txt-grey-64"
                        }, null, 8, ["txt"])
                      ]),
                      _createVNode(_component_text_item, {
                        txt: instituteAddress.address.country,
                        class: "txt-grey-64"
                      }, null, 8, ["txt"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["title"])
              ]),
              _: 2
            }, 1032, ["modelValue", "openOn"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('settings.params.account.details.contact')), 1),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewFix"
          }, {
            dropd: _withCtx(() => [
              _createVNode(PhoneInput, {
                iwr: _unref(instituteWithRole),
                newIsMobile: false,
                onClose: _cache[7] || (_cache[7] = ($event: any) => (dropd.value = '')),
                ownerType: "institute",
                onCreateInstitutePhone: _cache[8] || (_cache[8] = ($event: any) => (createPhone($event)))
              }, null, 8, ["iwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewMobile"
          }, {
            dropd: _withCtx(() => [
              _createVNode(PhoneInput, {
                iwr: _unref(instituteWithRole),
                newIsMobile: true,
                onClose: _cache[10] || (_cache[10] = ($event: any) => (dropd.value = '')),
                ownerType: "institute",
                onCreateInstitutePhone: _cache[11] || (_cache[11] = ($event: any) => (createPhone($event)))
              }, null, 8, ["iwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewEmail"
          }, {
            dropd: _withCtx(() => [
              _createVNode(EmailInput, {
                iwr: _unref(instituteWithRole),
                ownerType: "institute",
                onClose: _cache[13] || (_cache[13] = ($event: any) => (dropd.value = '')),
                onCreateInstituteEmail: _cache[14] || (_cache[14] = ($event: any) => (createEmail($event)))
              }, null, 8, ["iwr"])
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_dropdownBox, {
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((dropd).value = $event)),
            openOn: "addNewContact"
          }, {
            dropd: _withCtx(() => [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (dropd.value = 'addNewFix'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "phone",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: "Fixe",
                      class: "mleft-06"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  class: "mtop-04",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (dropd.value = 'addNewMobile'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "mobile",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: "Mobile",
                      class: "mleft-06"
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_list_group, {
                  styles: "pad-s",
                  class: "mtop-04",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (dropd.value = 'addNewEmail'))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_item, {
                      icon: "mail",
                      styles: "main-m"
                    }),
                    _createVNode(_component_text_item, {
                      txt: "Email",
                      class: "mleft-06"
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_button_group, null, {
                default: _withCtx(() => [
                  _createVNode(_component_svg_item, {
                    icon: "plus",
                    styles: "main-m"
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(institutePhones.value, (phone, indexPhone) => {
            return (_openBlock(), _createBlock(_component_dropdownBox, {
              key: indexPhone,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((dropd).value = $event)),
              openOn: 'input-phone-' + indexPhone,
              class: "cursor-action"
            }, {
              dropd: _withCtx(() => [
                _createVNode(PhoneInput, {
                  "is-update": true,
                  ref_for: true,
                  ref: 'input-phone-' + indexPhone,
                  phone: phone,
                  ownerType: "institute",
                  iwr: _unref(instituteWithRole),
                  onUpdateInstitutePhone: ($event: any) => (updatePhone($event, phone.institutePhoneId)),
                  onDeleteInstitutePhone: ($event: any) => (deletePhone(phone.institutePhoneId)),
                  onClose: _cache[20] || (_cache[20] = ($event: any) => (dropd.value = ''))
                }, null, 8, ["phone", "iwr", "onUpdateInstitutePhone", "onDeleteInstitutePhone"])
              ]),
              default: _withCtx(() => [
                _createVNode(EsDataCard, {
                  title: phone.isMobile ? _unref(t)('patient.admin.mobile') : _unref(t)('patient.admin.phone'),
                  icon: phone.isMobile ? 'iphone-gen2' : 'phone_fill',
                  folderIcon: 'shareIcons',
                  ref_for: true,
                  ref: 'phone-' + indexPhone,
                  backgroundClass: "bg-blue-04"
                }, {
                  default: _withCtx(() => [
                    (/^\d+$/.test(phone.phonePrefix) && _unref(PHONE_PREFIX_LIST).find(item => item.prefix === phone.phonePrefix))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "pleft-30px flex-row gap-02",
                          onClick: ($event: any) => (callNumber(phone))
                        }, [
                          _createVNode(_component_text_item, {
                            txt: _unref(getFlagEmojiForPrefix)(phone.phonePrefix) + ' +' + _unref(PHONE_PREFIX_LIST).find(item => item.prefix === phone.phonePrefix).prefix,
                            class: "txt-grey-64"
                          }, null, 8, ["txt"]),
                          _createVNode(_component_text_item, {
                            txt: contact(phone.phoneNumber),
                            class: "txt-grey-64"
                          }, null, 8, ["txt"])
                        ], 8, _hoisted_20))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_unref(PHONE_PREFIX_LIST).find(item => item.isoCode === phone.phonePrefix))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "pleft-30px flex-row gap-02",
                                onClick: ($event: any) => (callNumber(phone))
                              }, [
                                _createVNode(_component_text_item, {
                                  txt: _unref(getFlagEmojiForCountry)(phone.phonePrefix) + ' +' + _unref(PHONE_PREFIX_LIST).find(item => item.isoCode === phone.phonePrefix).prefix,
                                  class: "txt-grey-64"
                                }, null, 8, ["txt"]),
                                _createVNode(_component_text_item, {
                                  txt: contact(phone.phoneNumber),
                                  class: "txt-grey-64"
                                }, null, 8, ["txt"])
                              ], 8, _hoisted_21))
                            : _createCommentVNode("", true)
                        ], 64))
                  ]),
                  _: 2
                }, 1032, ["title", "icon"])
              ]),
              _: 2
            }, 1032, ["modelValue", "openOn"]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instituteEmails.value, (mail, indexMail) => {
            return (_openBlock(), _createBlock(_component_dropdownBox, {
              key: indexMail,
              modelValue: dropd.value,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((dropd).value = $event)),
              openOn: 'input-mail-' + indexMail,
              class: "cursor-action"
            }, {
              dropd: _withCtx(() => [
                _createVNode(EmailInput, {
                  "is-update": true,
                  ref_for: true,
                  ref: 'input-mail-' + indexMail,
                  ownerType: "institute",
                  email: mail,
                  iwr: _unref(instituteWithRole),
                  onUpdateInstituteEmail: ($event: any) => (updateEmail($event, mail.instituteEmailId)),
                  onDeleteInstituteEmail: ($event: any) => (deleteEmail(mail.instituteEmailId)),
                  onClose: _cache[22] || (_cache[22] = ($event: any) => (dropd.value = ''))
                }, null, 8, ["email", "iwr", "onUpdateInstituteEmail", "onDeleteInstituteEmail"])
              ]),
              default: _withCtx(() => [
                _createVNode(EsDataCard, {
                  title: _unref(t)('patient.admin.email'),
                  icon: 'envelope_fill',
                  folderIcon: 'shareIcons',
                  ref_for: true,
                  ref: 'mail-' + indexMail,
                  backgroundClass: "bg-blue-04"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "cursor-nosel main-h align-l bg-0 font-m ellipsis pleft-30px txt-grey-64",
                      onClick: ($event: any) => (sendEmail(mail.email))
                    }, _toDisplayString(mail.email), 9, _hoisted_22)
                  ]),
                  _: 2
                }, 1032, ["title"])
              ]),
              _: 2
            }, 1032, ["modelValue", "openOn"]))
          }), 128))
        ])
      ]),
      _cache[32] || (_cache[32] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('settings.params.account.prescription.title')), 1),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((dropd).value = $event)),
          openOn: "addNewHeader"
        }, {
          dropd: _withCtx(() => [
            _createVNode(headerInput, {
              iwr: _unref(instituteWithRole),
              onClose: _cache[25] || (_cache[25] = ($event: any) => (dropd.value = ''))
            }, null, 8, ["iwr"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_button_group, {
              onClick: _cache[24] || (_cache[24] = ($event: any) => (dropd.value = 'addNewHeader'))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "plus",
                  styles: "main-m"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(instituteHeaders.value, (header) => {
          return (_openBlock(), _createBlock(_component_dropdownBox, {
            key: header.instituteHeaderId,
            modelValue: dropd.value,
            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((dropd).value = $event)),
            openOn: 'input-header-' + header.instituteHeaderId,
            class: "cursor-action"
          }, {
            dropd: _withCtx(() => [
              _createVNode(headerInput, {
                iwr: _unref(instituteWithRole),
                header: header,
                onClose: _cache[27] || (_cache[27] = ($event: any) => (dropd.value = ''))
              }, null, 8, ["iwr", "header"])
            ]),
            default: _withCtx(() => [
              _createVNode(EsDataCard, {
                title: _unref(t)('settings.params.account.prescription.header'),
                icon: 'hashtag',
                folderIcon: 'shareIcons',
                backgroundClass: "bg-blue-04",
                class: "w-maxC"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_text_item, {
                      txt: header.customLine1 || _unref(t)('settings.params.account.prescription.labelCustomLine1'),
                      class: _normalizeClass(header.customLine1 ? 'txt-grey-64' : 'txt-grey-40')
                    }, null, 8, ["txt", "class"]),
                    _createVNode(_component_text_item, {
                      txt: header.customLine2 || _unref(t)('settings.params.account.prescription.labelCustomLine2'),
                      class: _normalizeClass(header.customLine2 ? 'txt-grey-64' : 'txt-grey-40')
                    }, null, 8, ["txt", "class"])
                  ])
                ]),
                _: 2
              }, 1032, ["title"])
            ]),
            _: 2
          }, 1032, ["modelValue", "openOn"]))
        }), 128))
      ]),
      _cache[33] || (_cache[33] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("h4", null, _toDisplayString(_unref(t)('settings.params.waitingRoom.title')), 1),
        _createVNode(esWaitingRoomSettings, {
          onRefreshCalendar: _cache[29] || (_cache[29] = ($event: any) => (emits('refresh-calendar', $event)))
        })
      ]),
      _cache[34] || (_cache[34] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.title')), 1),
        (slug.value != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("label", _hoisted_31, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.slug.title')), 1),
              _createVNode(esInstituteSlugSettings, {
                "input-id": "slug",
                slug: slug.value,
                "institute-id": _unref(instituteWithRole).instituteWithRoleId,
                onUpdateSlug: onSlugUpdate
              }, null, 8, ["slug", "institute-id"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("h4", null, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.generalMessage.title')), 1),
          _createVNode(EsEditor, {
            class: "flex-1 pad-m",
            "ref-editor": "generalMessageEditor",
            modelValue: instituteInformation.value.generalMessage,
            editorStyle: { height: '300px'},
            "heading-option": [],
            onTextChange: _cache[30] || (_cache[30] = ($event: any) => (updateGeneralMessage($event)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("h4", null, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.parking.title')), 1),
          _createVNode(esParkingSettings)
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("h4", null, _toDisplayString(_unref(t)('settings.params.account.institutes.portailPatient.transportStop.title')), 1),
          _createVNode(esTransportStopSettings)
        ])
      ])
    ])
  ]))
}
}

})